import React from "react";

export default class ScormErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="scorm-message scorm-message--error">
                    <strong>Le player SCORM n'a pas pu etre affiche.</strong>
                    <span>Rechargez le contenu ou contactez un responsable formation si le probleme persiste.</span>
                </div>
            );
        }

        return this.props.children;
    }
}
